import { Controller } from '@hotwired/stimulus';
import EmblaCarousel from 'embla-carousel';

export default class extends Controller {
    static targets = ['dots', 'dot'];

    #embla = null;

    connect () {
        this.#embla = EmblaCarousel(this.element, {});

        this.#embla
            .on('init', this.#addDots.bind(this))
            .on('reInit', this.#addDots.bind(this))
            .on('init', this.#selectDot.bind(this))
            .on('reInit', this.#selectDot.bind(this))
            .on('select', this.#selectDot.bind(this));
    }

    disconnect () {
        this.#embla.destroy();

        if (this.hasDotsTarget) {
            this.dotsTarget.innerHTML = '';
        }
    }

    scrollTo(event) {
        const index = this.dotTargets.indexOf(event.target);

        if (index > -1) {
            this.#embla.scrollTo(index);
        }
    }

    #addDots () {
        if (!this.hasDotsTarget) {
            return;
        }

        const snapList = this.#embla.scrollSnapList();

        if (snapList.length <= 1) {
            this.dotsTarget.innerHTML = '';
            return;
        }

        this.dotsTarget.innerHTML = this.#embla
            .scrollSnapList()
            .map(() => '<button type="button" data-embla-target="dot" data-action="embla#scrollTo"></button>')
            .join('')
    }

    #selectDot () {
        if (!this.hasDotTargets) {
            return;
        }

        const previous = this.#embla.previousScrollSnap()
        const selected = this.#embla.selectedScrollSnap()
        this.dotTargets[previous].classList.remove('current')
        this.dotTargets[selected].classList.add('current')
    }
}
